'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RenderIf;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function RenderIf(_ref) {
  var isTrue = _ref.isTrue,
      children = _ref.children;

  if (isTrue) {
    return children;
  }

  return null;
}

RenderIf.propTypes = {
  isTrue: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.object])
};
RenderIf.defaultProps = {
  isTrue: false,
  children: []
};